import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Title from './ProductTitle';
import Button from './Button';

const View = styled.div`
    pointer-events: ${props => (props.open ? 'all' : 'none')};
`;

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.3);
    transform: ${props => (!props.open ? 'translateY(-100%)' : 'none')};
    opacity: ${props => (props.open ? 1 : 0)};
    transition: opacity 0.3s ease-out;
    will-change: transform;
`;

const Container = styled.div`
    width: 100%;
    max-width: 500px;
    padding: 24px;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 4;
    background-color: #fff;
    transform: ${props =>
        props.open ? 'translate(-50%, -50%)' : 'translate(-50%, -350%)'};
    opacity: ${props => (props.open ? 1 : 0)};
    transition: opacity 0.3s 0.1s ease-out, transform 0.2s 0.1s ease-out;
    will-change: transform;
`;

const StyledTitle = styled(Title)`
    margin-bottom: 36px;
    color: #4b5860;
    line-height: 1.25;
    font-size: 22px;
`;

const Content = styled.div`
    font-size: 14px;
    color: #4b5860;
`;

const Actions = styled.div`
    margin-top: 42px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const SecondaryAction = styled.button`
    padding: 6px 12px;
    margin-right: 6px;
    background: none;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }

    &:focus {
        outline: none;
    }
`;

const PrimaryAction = styled(Button)`
    padding: 12px;
`;

const Dialog = props => {
    return (
        <View open={props.open}>
            <Backdrop open={props.open} />
            <Container open={props.open}>
                {props.title && (
                    <StyledTitle size="small">{props.title}</StyledTitle>
                )}
                <Content>{props.children}</Content>

                <Actions>
                    <SecondaryAction onClick={props.secondaryAction.onClick}>
                        {props.secondaryAction.label}
                    </SecondaryAction>

                    <PrimaryAction
                        onClick={props.primaryAction.onClick}
                        label={props.primaryAction.label}
                    />
                </Actions>
            </Container>
        </View>
    );
};

Dialog.defaultProps = {
    primaryAction: {
        onClick: () => {},
    },

    secondaryAction: {
        onClick: () => {},
    },
};

Dialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    secondaryAction: PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.string,
    }),
    primaryAction: PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.string,
    }),
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/shared/Dialog.js